export const ErrorHandle = {
  Message: {
    Common: 'アプリに問題が発生しました。\n',
    StatusCode: 'ステータスコード:#CODE',
    ConflictReserve:
      '既に予約が埋まっております。\n別の日時を設定の上、再度お試しください。',
    VersionMismatchReserve:
      '最新のデータが取得できませんでした。ホーム画面に戻ってからもう一度やり直してください。',
    Network:
      'サーバーへ接続できませんでした。\nインターネット接続をご確認ください。',
    Maintenance: {
      Title: 'メンテナンスのお知らせ',
      Content1: 'いつもご利用いただき、誠にありがとうございます。',
      Content2: '現在、メンテナンスを実施させていただいております。',
      Content3: 'ご迷惑をおかけして申し訳ありませんが、',
      Content4: 'しばらく時間をおいてから再度アクセスしてください。',
      Content5: 'お客様には大変ご迷惑をおかけいたしますが、',
      Content6: '何卒よろしくお願い申しあげます。',
    },
  },
  Button: {
    OK: 'OK',
    ReTry: '再接続',
    GoHome: 'ホームに戻る',
  },
};
